// extracted by mini-css-extract-plugin
export default {"root":"uM_Fv4uD8D"};